import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
    IconButton, Dialog, DialogTitle, DialogContent,
    Typography, Box, Avatar,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
  } from '@mui/material';
  import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import QRCode from "react-qr-code";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { db, doc, collection, onSnapshot } from '../FirebaseConfig';
import CopyableUrl from '../common/CopyableUrl';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));


function PaperComponent(props) {
    return (
        <Draggable
        handle=".draggable-handle, #draggable-dialog-title"
        cancel={'button, [class*="MuiIconButton-root"], input, textarea, .selectable-url'}
        >
        <Paper {...props} />
        </Draggable>
    );
}
///////////////////////////////////////////////////////////////////////////////////////////////
function createData(player, votes, stars) {
    return { player, votes, stars };
}
  

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

   

export default function PlayerModal({
    open, onClose, type, message, queryQR,
    userId,
    }) {
    const [rows, setRows] = useState(null);    
    const [playlist, setPlaylist] = useState(null);
    const [presetPlaylists, setPresetPlaylists] = useState(null);    
    const [directVotes, setDirectVotes] = useState([]);
    const [currentVideoData, setCurrentVideoData] = useState(null);

    /* eslint-disable */
    useEffect(() => {
        if (!userId || userId === -1) return;
        const docRef = doc(db, 'users', userId);

        // 1. Escuchar datos del documento principal del anfitrión
        const unsubscribeDoc = onSnapshot(docRef, (docSnap) => {
            if (docSnap.exists()) {
                const data = docSnap.data();
                setPlaylist(Array.isArray(data.playlist) ? data.playlist : []);
                setPresetPlaylists(Array.isArray(data.presetPlaylists) ? data.presetPlaylists : []);
                if (data.currentVideoData) {
                    try {
                        const parsed = typeof data.currentVideoData === 'string' ? JSON.parse(data.currentVideoData) : data.currentVideoData;
                        setCurrentVideoData(parsed);
                    } catch (e) {
                        setCurrentVideoData(data.currentVideoData);
                    }
                }
            } else {
                console.log('Document does not exist');
            }
        });

        // 2. Escuchar votos en tiempo real de la subcolección atómica 'votes'
        let unsubscribeVotes = () => {};
        try {
            const votesColRef = collection(db, 'users', userId, 'votes');
            unsubscribeVotes = onSnapshot(votesColRef, (snapshot) => {
                const votesList = [];
                snapshot.forEach((d) => {
                    votesList.push({ id: d.id, ...d.data() });
                });
                console.log(`🗳️ [PlayerModal] ${votesList.length} votos en subcolección 'votes' recibidos`);
                setDirectVotes(votesList);
            }, (err) => {
                console.warn('Advertencia escuchando subcolección votes en PlayerModal:', err);
            });
        } catch (err) {
            console.warn('Error inicializando listener de subcolección votes:', err);
        }

        // 3. Escuchar votos locales inmediatos vía BroadcastChannel
        let bc = null;
        try {
            if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
                bc = new BroadcastChannel('garaoke_player_sync');
                bc.onmessage = (ev) => {
                    if (ev?.data?.type === 'VOTE_REGISTERED' || ev?.data?.type === 'VOTE_SUBMITTED') {
                        const newVote = ev.data;
                        console.log('🗳️ [PlayerModal] Voto recibido vía BroadcastChannel:', newVote);
                        setDirectVotes(prev => {
                            const exists = prev.some(v => v.userId === newVote.userId && v.videoId === newVote.videoId);
                            if (exists) {
                                return prev.map(v => (v.userId === newVote.userId && v.videoId === newVote.videoId) ? { ...v, ...newVote } : v);
                            }
                            return [...prev, newVote];
                        });
                    } else if (ev?.data?.type === 'VOTES_RESET') {
                        console.log('🗳️ [PlayerModal] Votaciones reiniciadas vía BroadcastChannel');
                        setDirectVotes([]);
                        setRows([]);
                    }
                };
            }
        } catch (e) {}

        return () => {
            unsubscribeDoc();
            unsubscribeVotes();
            if (bc) bc.close();
        };
    }, [userId]);


    useEffect(() => {
        setRows(generateRowsRatings());
    }, [playlist, presetPlaylists, directVotes, currentVideoData]);


    const generateRowsRatings = () => {
        let playerStats = {};
        const countedVoteKeys = new Set();

        const addVote = (player, starVal, voteKey) => {
            if (!player || typeof player !== 'string' || !player.trim()) return;
            const p = player.trim();
            const val = Number(starVal);
            if (isNaN(val) || val <= 0) return;

            if (voteKey) {
                if (countedVoteKeys.has(voteKey)) return;
                countedVoteKeys.add(voteKey);
            }

            if (!playerStats[p]) {
                playerStats[p] = { totalStars: 0, votes: 0 };
            }
            playerStats[p].totalStars += val;
            playerStats[p].votes += 1;
        };

        // 1. Procesar votos de la subcolección atómica 'votes'
        if (Array.isArray(directVotes)) {
            directVotes.forEach((v) => {
                let performer = (v.performer && v.performer.toLowerCase() !== 'cantante')
                    ? v.performer
                    : (v.assignedTo && v.assignedTo.toLowerCase() !== 'cantante' ? v.assignedTo : '');

                if (!performer && v.videoId) {
                    if (Array.isArray(playlist)) {
                        const match = playlist.find(it => (it.videoId === v.videoId || it.id === v.videoId || it.item?.videoId === v.videoId));
                        const plSinger = match?.assignedTo || match?.item?.assignedTo || match?.singer;
                        if (plSinger && plSinger.toLowerCase() !== 'cantante') performer = plSinger;
                    }
                    if (!performer && Array.isArray(presetPlaylists)) {
                        for (const pl of presetPlaylists) {
                            if (Array.isArray(pl?.items)) {
                                const match = pl.items.find(it => (it.videoId === v.videoId || it.id === v.videoId || it.item?.videoId === v.videoId));
                                const plSinger = match?.assignedTo || match?.item?.assignedTo || match?.singer;
                                if (plSinger && plSinger.toLowerCase() !== 'cantante') { performer = plSinger; break; }
                            }
                        }
                    }
                    if (!performer && currentVideoData?.videoId === v.videoId && currentVideoData?.assignedTo && currentVideoData.assignedTo.toLowerCase() !== 'cantante') {
                        performer = currentVideoData.assignedTo;
                    }
                }
                if (!performer) {
                    performer = (v.performer || v.assignedTo || v.title || 'Participante');
                }

                const voteKey = v.id || `${v.videoId || ''}_${v.userId || ''}`;
                const starVal = v.vote ?? v.stars;
                addVote(performer, starVal, voteKey);
            });
        }

        // 2. Procesar votos embebidos en playlist
        const processItem = (item) => {
            if (!item || !item.assignedTo || !Array.isArray(item.votes)) return;
            const player = item.assignedTo;
            item.votes.forEach((vote, idx) => {
                const userId = typeof vote === 'object' ? vote?.userId : `idx_${idx}`;
                const voteKey = `${item.videoId || ''}_${userId || ''}`;
                const val = typeof vote === 'object' ? Number(vote?.vote ?? vote?.stars) : Number(vote);
                addVote(player, val, voteKey);
            });
        };

        if (Array.isArray(playlist)) {
            playlist.forEach(processItem);
        }

        // 3. Procesar votos embebidos en presetPlaylists
        if (Array.isArray(presetPlaylists)) {
            presetPlaylists.forEach((presetPlaylist) => {
                if (presetPlaylist && Array.isArray(presetPlaylist.items)) {
                    presetPlaylist.items.forEach(processItem);
                }
            });
        }

        let output = [];
        Object.keys(playerStats).forEach((player) => {
            const data = playerStats[player];
            if (data.votes > 0) {
                const avgStars = data.totalStars / data.votes;
                output.push(createData(player, data.votes, Number(avgStars.toFixed(1))));
            }
        });

        return output.sort((a, b) => b.stars - a.stars);
    };

    const getAvatarColor = (index, name = '') => {
        if (index === 0) return 'linear-gradient(135deg, #ffd700 0%, #ff8c00 100%)';
        if (index === 1) return 'linear-gradient(135deg, #cfd8dc 0%, #78909c 100%)';
        if (index === 2) return 'linear-gradient(135deg, #d7ccc8 0%, #8d6e63 100%)';
        const gradients = [
            'linear-gradient(135deg, #ff2d9b 0%, #b44dff 100%)',
            'linear-gradient(135deg, #00d4ff 0%, #0066ff 100%)',
            'linear-gradient(135deg, #00ff88 0%, #00a86b 100%)',
            'linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)',
        ];
        const hash = (name || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        return gradients[hash % gradients.length];
    };

    const getRankBadge = (index) => {
        if (index === 0) return '🥇';
        if (index === 1) return '🥈';
        if (index === 2) return '🥉';
        return `#${index + 1}`;
    };

    const generateStarRating = (rating) => {
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.3;
        const emptyStars = Math.max(0, 5 - fullStars - (hasHalfStar ? 1 : 0));
        const stars = [];
        for (let i = 0; i < fullStars; i++) {
            stars.push(<StarIcon sx={{ color: '#ffd700', fontSize: '1.25rem', filter: 'drop-shadow(0 0 3px rgba(255, 215, 0, 0.6))' }} key={`full-${i}`} />);
        }
        if (hasHalfStar) {
            stars.push(<StarHalfIcon sx={{ color: '#ffd700', fontSize: '1.25rem', filter: 'drop-shadow(0 0 3px rgba(255, 215, 0, 0.6))' }} key="half" />);
        }
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<StarBorderIcon sx={{ color: 'rgba(255, 255, 255, 0.25)', fontSize: '1.25rem' }} key={`empty-${i}`} />);
        }
        return stars;
    };

    const generateVotesTable = (rowsResult) => {
        if (!rowsResult || rowsResult.length === 0) {
            return (
                <Box sx={{ py: 4, px: 2, textAlign: 'center' }}>
                    <span style={{ fontSize: '2.5rem' }}>🎤</span>
                    <Typography sx={{ mt: 1.5, color: '#ffffff', fontWeight: 800, fontSize: '1.15rem' }}>
                        ¡Aún no hay votos registrados!
                    </Typography>
                    <Typography sx={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '0.88rem', mt: 0.5 }}>
                        Escaneá el código QR desde tu celular para empezar a calificar a los cantantes.
                    </Typography>
                </Box>
            );
        }

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {rowsResult.length > 3 && (
                    <Box sx={{
                        py: 0.6,
                        px: 1.5,
                        borderRadius: '10px',
                        background: 'linear-gradient(90deg, rgba(255, 215, 0, 0.12) 0%, rgba(180, 77, 255, 0.15) 100%)',
                        border: '1px solid rgba(255, 215, 0, 0.3)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 0.5,
                    }}>
                        <Typography sx={{ color: '#ffd700', fontSize: '0.8rem', fontWeight: 800 }}>
                            🌟 {rowsResult.length} participantes con votos
                        </Typography>
                        <Typography sx={{ color: 'rgba(255, 255, 255, 0.65)', fontSize: '0.76rem', fontWeight: 600 }}>
                            ↓ Desliza para ver la tabla completa
                        </Typography>
                    </Box>
                )}
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.2,
                    maxHeight: { xs: '340px', sm: '430px', md: '490px' },
                    overflowY: 'auto',
                    pr: 1,
                    // Scrollbar estética neón acorde al diseño de Garaoke
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: 'linear-gradient(180deg, #ffd700 0%, #b44dff 100%)',
                        borderRadius: '10px',
                        border: '2px solid rgba(16, 5, 29, 0.8)',
                        boxShadow: '0 0 10px rgba(180, 77, 255, 0.4)',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: 'linear-gradient(180deg, #ffe033 0%, #d070ff 100%)',
                    },
                }}>
                {rowsResult.map((row, index) => {
                    const isFirst = index === 0;
                    const initial = row.player ? row.player.trim().charAt(0).toUpperCase() : '?';
                    return (
                        <Box
                            key={row.player + index}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                p: { xs: 1.2, sm: 1.5 },
                                px: { xs: 1.6, sm: 2.2 },
                                borderRadius: '16px',
                                background: isFirst 
                                    ? 'linear-gradient(90deg, rgba(255, 215, 0, 0.18) 0%, rgba(255, 140, 0, 0.1) 100%)' 
                                    : 'rgba(255, 255, 255, 0.04)',
                                border: '1px solid',
                                borderColor: isFirst ? 'rgba(255, 215, 0, 0.55)' : 'rgba(255, 255, 255, 0.1)',
                                boxShadow: isFirst ? '0 4px 20px rgba(255, 215, 0, 0.25)' : 'none',
                                transition: 'transform 0.2s ease, background 0.2s ease',
                                '&:hover': {
                                    transform: 'scale(1.01)',
                                    background: isFirst ? 'rgba(255, 215, 0, 0.22)' : 'rgba(255, 255, 255, 0.08)',
                                }
                            }}
                        >
                            {/* Lado izquierdo: Posición + Avatar + Nombre */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.6, minWidth: 0 }}>
                                <Typography 
                                    sx={{ 
                                        fontWeight: 900, 
                                        fontSize: index < 3 ? '1.5rem' : '1rem',
                                        width: 32,
                                        textAlign: 'center',
                                        color: index < 3 ? '#ffd700' : 'rgba(255, 255, 255, 0.5)',
                                        flexShrink: 0
                                    }}
                                >
                                    {getRankBadge(index)}
                                </Typography>

                                <Avatar
                                    sx={{
                                        width: 44,
                                        height: 44,
                                        fontWeight: 900,
                                        fontSize: '1.2rem',
                                        color: '#ffffff',
                                        background: getAvatarColor(index, row.player),
                                        border: isFirst ? '2px solid #ffd700' : '2px solid rgba(255, 255, 255, 0.25)',
                                        boxShadow: isFirst ? '0 0 14px rgba(255, 215, 0, 0.6)' : '0 2px 8px rgba(0, 0, 0, 0.4)',
                                        flexShrink: 0
                                    }}
                                >
                                    {initial}
                                </Avatar>

                                <Box sx={{ minWidth: 0 }}>
                                    <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#ffffff',
                                            fontSize: { xs: '1.05rem', sm: '1.2rem' },
                                            lineHeight: 1.2,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            textShadow: '0 2px 8px rgba(0, 0, 0, 0.7)'
                                        }}
                                    >
                                        {row.player || 'Participante'}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            color: 'rgba(255, 255, 255, 0.65)',
                                            fontSize: '0.82rem',
                                            fontWeight: 600,
                                            mt: 0.2
                                        }}
                                    >
                                        {row.votes} {row.votes === 1 ? 'voto registrado' : 'votos registrados'}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* Lado derecho: Estrellas + Puntuación numérica */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexShrink: 0, ml: 2 }}>
                                <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}>
                                    {generateStarRating(row.stars)}
                                </Box>
                                <Box 
                                    sx={{
                                        px: 1.4,
                                        py: 0.4,
                                        borderRadius: '12px',
                                        background: isFirst ? 'rgba(255, 215, 0, 0.22)' : 'rgba(255, 255, 255, 0.08)',
                                        border: '1px solid',
                                        borderColor: isFirst ? '#ffd700' : 'rgba(255, 255, 255, 0.18)',
                                        minWidth: 48,
                                        textAlign: 'center'
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 900,
                                            fontSize: '1.15rem',
                                            color: isFirst ? '#ffd700' : '#ffffff',
                                            letterSpacing: '0.5px'
                                        }}
                                    >
                                        {Number(row.stars).toFixed(1)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    );
                })}
                </Box>
            </Box>
        );
    };






















    const querySuffix = queryQR || (userId && userId !== -1 ? `?UID=${userId}` : '');

    const getMonitorUrl = () => {
      // 1. Variable de entorno explícita (VITE_PUBLIC_URL o REACT_APP_BASE_URL)
      const envUrl = process.env.VITE_PUBLIC_URL || process.env.VITE_BASE_URL || process.env.REACT_APP_BASE_URL;
      if (envUrl) {
        return envUrl.replace(/\/$/, '') + '/monitor' + querySuffix;
      }

      // 2. Si estamos en el navegador
      if (typeof window !== 'undefined' && window.location) {
        const { protocol, hostname, port } = window.location;
        const portSuffix = port ? `:${port}` : '';

        // Si ya está accediendo mediante la IP de red local (ej: 192.168.x.x) o un dominio
        if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
          return `${protocol}//${hostname}${portSuffix}/monitor${querySuffix}`;
        }

        // Si está en localhost pero se configuró VITE_LOCAL_IP en .env
        const localIp = process.env.VITE_LOCAL_IP;
        if (localIp) {
          return `${protocol}//${localIp}${portSuffix}/monitor${querySuffix}`;
        }

        return `${window.location.origin}/monitor${querySuffix}`;
      }

      return 'http://localhost:3000/monitor' + querySuffix;
    };

    const QRCodeUrl = getMonitorUrl();

    return (
      <BootstrapDialog
        PaperComponent={PaperComponent}
        onClose={onClose}
        aria-labelledby="draggable-dialog-title"
        open={open}
        hideBackdrop={true}
        PaperProps={{
          sx: {
            background: 'linear-gradient(135deg, rgba(16, 5, 29, 0.90) 0%, rgba(38, 8, 52, 0.93) 50%, rgba(20, 4, 38, 0.92) 100%)',
            backdropFilter: 'blur(22px)',
            WebkitBackdropFilter: 'blur(22px)',
            borderRadius: '24px',
            border: '2px solid',
            borderColor: type === 'QR' 
              ? 'rgba(0, 212, 255, 0.65)' 
              : type === 'Votes' 
                ? 'rgba(180, 77, 255, 0.65)' 
                : 'rgba(255, 45, 155, 0.65)',
            boxShadow: type === 'QR'
              ? '0 25px 70px rgba(0, 0, 0, 0.95), 0 0 45px rgba(0, 212, 255, 0.35), inset 0 0 25px rgba(0, 212, 255, 0.15)'
              : type === 'Votes'
                ? '0 25px 70px rgba(0, 0, 0, 0.95), 0 0 45px rgba(180, 77, 255, 0.35), inset 0 0 25px rgba(180, 77, 255, 0.2)'
                : '0 25px 70px rgba(0, 0, 0, 0.95), 0 0 45px rgba(255, 45, 155, 0.4), inset 0 0 25px rgba(180, 77, 255, 0.25)',
            color: '#ffffff',
            minWidth: type === 'Votes' ? { xs: 320, sm: 560, md: 700 } : { xs: 320, sm: 440, md: 520 },
            maxWidth: '92vw',
            maxHeight: '88vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            position: 'relative',
          }
        }}
      >
        {type === 'QR' && (
          <Box
            className="draggable-handle"
            id="draggable-dialog-title"
            sx={{
              position: 'relative',
              py: { xs: 3.5, sm: 4.5 },
              px: { xs: 3, sm: 5 },
              textAlign: 'center',
              cursor: 'grab',
              '&:active': { cursor: 'grabbing' },
              userSelect: 'none',
              overflow: 'hidden'
            }}
          >
            {/* Botón de cerrar flotante */}
            <IconButton
              aria-label="close"
              onClick={onClose}
              size="small"
              sx={{
                position: 'absolute',
                right: 14,
                top: 14,
                zIndex: 2,
                color: 'rgba(255, 255, 255, 0.7)',
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '50%',
                p: '6px',
                transition: 'all 0.2s',
                '&:hover': {
                  color: '#ffffff',
                  background: 'rgba(0, 212, 255, 0.6)',
                  transform: 'scale(1.1)'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Resplandor radial cyan de fondo */}
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '85%',
                height: '85%',
                background: 'radial-gradient(circle, rgba(0, 212, 255, 0.22) 0%, rgba(180, 77, 255, 0.08) 50%, transparent 70%)',
                pointerEvents: 'none',
                zIndex: 0
              }}
            />

            {/* Título y subtítulo festivo del QR */}
            <Box sx={{ position: 'relative', zIndex: 1, mb: 2.5 }}>
              <Typography
                component="div"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: '1.4rem', sm: '1.8rem' },
                  letterSpacing: '0.5px',
                  background: 'linear-gradient(90deg, #00d4ff 0%, #00ffc4 50%, #ffffff 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  textShadow: '0 2px 20px rgba(0, 212, 255, 0.5)'
                }}
              >
                📱 ¡Escaneá y Votá en Vivo!
              </Typography>
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.9rem', mt: 0.5, fontWeight: 600 }}>
                Abrí la cámara de tu teléfono para ingresar y calificar 🎤
              </Typography>
            </Box>

            {/* Código QR enmarcado con contraste */}
            <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                display: 'inline-flex',
                p: 2,
                borderRadius: '20px',
                background: '#ffffff',
                boxShadow: '0 12px 35px rgba(0, 212, 255, 0.35)',
                border: '3px solid rgba(0, 212, 255, 0.5)'
              }}
            >
              <QRCode value={QRCodeUrl} size={220} />
            </Box>

            {/* URL amigable seleccionable con botón discreto de copiar */}
            <CopyableUrl url={QRCodeUrl} maxWidth="92%" sx={{ mt: 2 }} />
          </Box>
        )}

        {type === 'Message' && (
          <Box
            className="draggable-handle"
            id="draggable-dialog-title"
            sx={{
              position: 'relative',
              py: { xs: 4, sm: 5, md: 6 },
              px: { xs: 4, sm: 6, md: 7 },
              textAlign: 'center',
              cursor: 'grab',
              '&:active': { cursor: 'grabbing' },
              userSelect: 'none',
              overflow: 'hidden'
            }}
          >
            {/* Botón de cerrar flotante en la esquina superior derecha */}
            <IconButton
              aria-label="close"
              onClick={onClose}
              size="small"
              sx={{
                position: 'absolute',
                right: 14,
                top: 14,
                zIndex: 2,
                color: 'rgba(255, 255, 255, 0.7)',
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '50%',
                p: '6px',
                transition: 'all 0.2s',
                '&:hover': {
                  color: '#ffffff',
                  background: 'rgba(255, 45, 155, 0.6)',
                  transform: 'scale(1.1)'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Resplandor radial de fondo */}
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '85%',
                height: '85%',
                background: 'radial-gradient(circle, rgba(255, 45, 155, 0.22) 0%, rgba(180, 77, 255, 0.08) 50%, transparent 70%)',
                pointerEvents: 'none',
                zIndex: 0
              }}
            />

            {/* Texto del mensaje */}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Typography
                component="div"
                sx={{
                  fontSize: { xs: '1.8rem', sm: '2.6rem', md: '3.4rem' },
                  fontWeight: 900,
                  lineHeight: 1.2,
                  letterSpacing: '-0.5px',
                  fontFamily: '"Outfit", "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                  color: '#ffffff',
                  textShadow: '0 4px 20px rgba(0, 0, 0, 0.9), 0 0 25px rgba(255, 45, 155, 0.65), 0 0 50px rgba(180, 77, 255, 0.45)',
                  wordBreak: 'break-word',
                  hyphens: 'auto',
                }}
              >
                {message || '¡A cantar se ha dicho! 🎤🎶'}
              </Typography>
            </Box>
          </Box>
        )}

        {type === 'Votes' && (
          <Box
            className="draggable-handle"
            id="draggable-dialog-title"
            sx={{
              position: 'relative',
              py: { xs: 3, sm: 4 },
              px: { xs: 2.5, sm: 3.5 },
              cursor: 'grab',
              '&:active': { cursor: 'grabbing' },
              userSelect: 'none',
              overflow: 'hidden'
            }}
          >
            {/* Botón de cerrar flotante */}
            <IconButton
              aria-label="close"
              onClick={onClose}
              size="small"
              sx={{
                position: 'absolute',
                right: 14,
                top: 14,
                zIndex: 2,
                color: 'rgba(255, 255, 255, 0.7)',
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '50%',
                p: '6px',
                transition: 'all 0.2s',
                '&:hover': {
                  color: '#ffffff',
                  background: 'rgba(180, 77, 255, 0.6)',
                  transform: 'scale(1.1)'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Resplandor radial violeta de fondo */}
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '85%',
                height: '85%',
                background: 'radial-gradient(circle, rgba(180, 77, 255, 0.22) 0%, rgba(255, 45, 155, 0.08) 50%, transparent 70%)',
                pointerEvents: 'none',
                zIndex: 0
              }}
            />

            {/* Título de la tabla */}
            <Box sx={{ position: 'relative', zIndex: 1, mb: 2.5, textAlign: 'center' }}>
              <Typography
                component="div"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: '1.4rem', sm: '1.9rem' },
                  letterSpacing: '0.5px',
                  background: 'linear-gradient(90deg, #ffd700 0%, #ff8c00 50%, #ff2d9b 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  textShadow: '0 2px 20px rgba(255, 215, 0, 0.4)'
                }}
              >
                🏆 Tabla de Resultados
              </Typography>
              <Typography sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.88rem', mt: 0.3, fontWeight: 600 }}>
                Ranking en vivo del show de karaoke 🌟
              </Typography>
            </Box>

            {/* Contenido del ranking */}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              {rows !== null && generateVotesTable(rows)}
            </Box>
          </Box>
        )}
      </BootstrapDialog>
    );

}